// Translate an unknown thrown value (typically an ofetch FetchError) into a
// user-facing string. Never returns ofetch's default `error.message` (the
// verbose `[POST] "url": <status>` string), which was previously leaking
// through to the login UI.
//
// Note: the backend currently returns 500 for bad-credential / bad-input
// responses where 400 would be expected, so both codes map to `badRequest`.
export function formatAuthError(
	error: unknown,
	messages: { badRequest: string; generic: string },
): string {
	if (error && typeof error === 'object' && 'statusCode' in error) {
		const fetchError = error as {
			statusCode: number;
			data?: { title?: string; detail?: string };
		};

		if (fetchError.statusCode === 400 || fetchError.statusCode === 500) {
			return messages.badRequest;
		}

		switch (fetchError.statusCode) {
			case 401:
				return 'You are not logged in or your session has expired. Please log in again.';
			case 429:
				return 'Too many attempts. Please wait a moment and try again.';
		}

		if (fetchError.statusCode > 500) {
			return 'The server is temporarily unavailable. Please try again in a moment.';
		}

		return fetchError.data?.title || fetchError.data?.detail || messages.generic;
	}

	if (error instanceof Error && error.message) {
		return error.message;
	}

	return messages.generic;
}
